import {createStore} from "redux"
const QUOTES = [
  {
    "quote": "“Love is that condition in which the happiness of another person is essential to your own.”",
    "author": "—Robert A. Heinlein"
  },
  {
    "quote": "“Let us always meet each other with smile, for the smile is the beginning of love.”",
    "author": "—Mother Teresa"
  },
  {
    "quote": "“You can search throughout the entire universe for someone who is more deserving of your love and affection than you are yourself, and that person is not to be found anywhere. You yourself, as much as anybody in the entire universe deserve your love and affection.”",
    "author": "—Gautama Buddha"
  },
  {
    "quote": "“Love is friendship that has caught fire. It is a quiet understanding, mutual confidence, sharing and forgiving. It is loyalty through good and bad times. It settles for less than perfection and makes allowances for human weaknesses.”",
    "author": "—Ann Landers"
  },
  {
    "quote": "“Being deeply loved by someone gives you strength, while loving someone deeply gives you courage.”",
    "author": "—Lao Tzu"
  },
  {
    "quote": "“Love is the only force capable of transforming an enemy into friend.”",
    "author": "—Martin Luther King, Jr."
  },
  {
    "quote": "“Our first and last love is self-love.”",
    "author": "—Christian Nestell Bovee"
  },
  {
    "quote": "“You will find as you look back upon your life that the moments when you have truly lived are the moments when you have done things in the spirit of love.”",
    "author": "—Henry Drummond"
  },
  {
    "quote": "“Love recognizes no barriers. It jumps hurdles, leaps fences, penetrates walls to arrive at its destination full of hope.”",
    "author": "—Maya Angelou"
  },
  {
    "quote": "“Love and compassion are necessities, not luxuries. Without them humanity cannot survive.”",
    "author": "—Dalai Lama"
  } 
]// const QUOTES

const NEW = "NEW";
const newQuote = (i) => ({
  type: NEW,
  index: i
})
export const mapD2P = (dispatch) => ({
  newQuote: (i) => dispatch(newQuote(i))
})
export const mapS2P = (state) => ({
  state
})
//→→→→→→→→→→→→→→→→→→→→→→→→→→→→→→→→→→→→→→→→→→
const initialState = {
  currentQuote: QUOTES[Math.floor(Math.random()*10)]
}
const reducer = (state=initialState, action) => {
  switch(action.type) {
    case(NEW)
    : return state.currentQuote === QUOTES[action.index]
      ? (() => {
        let index = action.index;
        while(action.index === index) {
          index = Math.floor(Math.random()*10)
        }
        return Object.assign({}, state, {currentQuote: QUOTES[index]})
      })()
      : Object.assign({}, state, {currentQuote: QUOTES[action.index]})
    default
    : return state
  }
}
export const store = createStore(reducer);